export default __webpack_public_path__ + "static/simple-line-32dfa68f7addcd883e28cb9bba60856d.png";